'use strict';
/**
 * This package contains deployed contract addresses, ABIs, and Typechain types
 * for the Dark Forest game.
 *
 * ## Installation
 *
 * You can install this package using [`npm`](https://www.npmjs.com) or
 * [`yarn`](https://classic.yarnpkg.com/lang/en/) by running:
 *
 * ```bash
 * npm install --save @darkforest_eth/contracts
 * ```
 * ```bash
 * yarn add @darkforest_eth/contracts
 * ```
 *
 * When using this in a plugin, you might want to load it with [skypack](https://www.skypack.dev)
 *
 * ```js
 * import * as contracts from 'http://cdn.skypack.dev/@darkforest_eth/contracts'
 * ```
 *
 * ## Typechain
 *
 * The Typechain types can be found in the `typechain` directory.
 *
 * ## ABIs
 *
 * The contract ABIs can be found in the `abis` directory.
 *
 * @packageDocumentation
 */
Object.defineProperty(exports, '__esModule', { value: true });
exports.GPT_CREDIT_CONTRACT_ADDRESS =
  exports.WHITELIST_CONTRACT_ADDRESS =
  exports.GETTERS_CONTRACT_ADDRESS =
  exports.TOKENS_CONTRACT_ADDRESS =
  exports.CORE_CONTRACT_ADDRESS =
  exports.LAZY_UPDATE_LIBRARY_ADDRESS =
  exports.INITIALIZE_LIBRARY_ADDRESS =
  exports.VERIFIER_LIBRARY_ADDRESS =
  exports.ARTIFACT_UTILS_LIBRARY_ADDRESS =
  exports.PLANET_LIBRARY_ADDRESS =
  exports.UTILS_LIBRARY_ADDRESS =
  exports.START_BLOCK =
  exports.NETWORK_ID =
  exports.NETWORK =
    void 0;
/**
 * The name of the network where these contracts are deployed.
 */
exports.NETWORK = 'xdai';
/**
 * The id of the network where these contracts are deployed.
 */
exports.NETWORK_ID = 100;
/**
 * The block in which the DarkForestCore contract was deployed.
 */
exports.START_BLOCK = 16750188;
/**
 * The address for the DarkForestUtils library.
 */
exports.UTILS_LIBRARY_ADDRESS = '0x56929362F772146CfeB7b08f4eDA7a6F7cfa51B7';
/**
 * The address for the DarkForestPlanet library.
 */
exports.PLANET_LIBRARY_ADDRESS = '0x6Db5d1D44EF9ffD308238914C9C8fC949EEd4Bf7';
/**
 * The address for the DarkForestArtifactUtils library.
 */
exports.ARTIFACT_UTILS_LIBRARY_ADDRESS = '0x590b47Ea6Cb629AD8a9228886e6C1DAA7a31630c';
/**
 * The address for the Verifier library.
 */
exports.VERIFIER_LIBRARY_ADDRESS = '0xF5c5c86B592a00d2d68958ABA4A316A4B0eBaDac';
/**
 * The address for the DarkForestInitialize library.
 */
exports.INITIALIZE_LIBRARY_ADDRESS = '0x26ddc1F8119B5A358Dd501eC167d6380e38c0e31';
/**
 * The address for the DarkForestLazyUpdate library.
 */
exports.LAZY_UPDATE_LIBRARY_ADDRESS = '0x56603474D7FfAFD6A03c7D5bB7E87B7b99e7f536';
/**
 * The address for the DarkForestCore contract.
 */
exports.CORE_CONTRACT_ADDRESS = '0x0F8E1785f850d4bF1155614883c2cB778a69c463';
/**
 * The address for the DarkForestTokens contract.
 */
exports.TOKENS_CONTRACT_ADDRESS = '0xafb1A0C81c848Ad530766aD4BE2fdddC833e1e96';
/**
 * The address for the DarkForestGetters contract.
 */
exports.GETTERS_CONTRACT_ADDRESS = '0xb85aAAB2272A95Fd3E929cF8ad16a5EC012c7bfA';
/**
 * The address for the Whitelist contract.
 */
exports.WHITELIST_CONTRACT_ADDRESS = '0x71CB56Dbb60ef54eA639BE325f5BD4295e09aAb6';
/**
 * The address for the DarkForestGPTCredit contract.
 */
exports.GPT_CREDIT_CONTRACT_ADDRESS = '0x399df8CD854F0C875A8ce770d29f39093bE4a18f';
